
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormatNumberPipe } from '@portal-shared/app/pipes/format-number.pipe';

@Component({
    selector: 'al-period-sums',
    templateUrl: './period-sums.component.html',
    styleUrls: ['./period-sums.component.scss'],
    imports: [FormatNumberPipe, TranslateModule]
})
export class PeriodSumsComponent {
  @Input()
  public actualHours?: number;

  @Input()
  public plannedHours = 0;

  @Input()
  public isVisible?: boolean;
}
